// angular import
import { Component, Input, NgZone, OnInit } from '@angular/core';
import { NavigationItem } from '../../navigation';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationsService } from '../../../configuration/service/configurations.service';
import { TfService } from 'src/app/tf/tf-service.service';
import { QuotationSettingService } from 'src/app/Theme/shared/service/quotation-setting/quotation-setting.service';

@Component({
  selector: 'app-nav-group',
  templateUrl: './nav-group.component.html',
  styleUrls: ['./nav-group.component.scss']
})
export class NavGroupComponent implements OnInit {
// public props
langset;
themeConfig
@Input() item: NavigationItem;
@Input() allowedPermissions: Record<string, boolean> | null = null;
@Input() isPhoneViewport = false;
user: 'admin' | 'contact' | null = null;
quotationAllowed = false;
quotationFeatureLoaded = false;

// constructor
constructor(private zone: NgZone,
   private location: Location,
   public translate: TranslateService,
  //  public langService:LanguageService,
   private ConfigurationsService: ConfigurationsService,
   private tfService: TfService,
   private quotationSettingService: QuotationSettingService
  ) {
    this.ConfigurationsService.getConfig().subscribe((res) => {
      this.themeConfig = res;});
  // this.langset = localStorage.getItem("lang")
  // this.langService.setLanguage(this.langset);
}

get hasVisibleChildren(): boolean {
  return (this.item?.children || []).some((child) => this.isChildVisible(child));
}

private isChildVisible(child: NavigationItem): boolean {
  if (!child || child.hidden) {
    return false;
  }
  if (child.mobileOnly && !this.isPhoneViewport) {
    return false;
  }
  if (child.type === 'group') {
    return (child.children || []).some((nested) => this.isChildVisible(nested));
  }
  if (child.role && child.role !== this.user) {
    return false;
  }
  if (child.permission) {
    if (this.allowedPermissions == null) {
      return false;
    }
    if (this.allowedPermissions[child.permission] !== true) {
      return false;
    }
  }
  if (this.user === 'contact') {
    const groups = this.tfService.getUserGroupsFromLocalStorage();
    if (child.contactGroupsAny?.length && !child.contactGroupsAny.some((g) => groups.includes(g))) {
      return false;
    }
    if (child.contactGroupsNoneOf?.length && child.contactGroupsNoneOf.some((g) => groups.includes(g))) {
      return false;
    }
  }
  if (child.requiresQuotationEnabled) {
    if (!this.quotationFeatureLoaded || !this.quotationAllowed) {
      return false;
    }
  }
  return true;
}

// life cycle event
ngOnInit() {
  const groups = this.tfService.getUserGroupsFromLocalStorage();
  this.user = groups.includes('admin') ? 'admin' : 'contact';
  this.quotationSettingService.isQuotationAllowed().subscribe((allowed) => {
    this.quotationAllowed = allowed;
    this.quotationFeatureLoaded = true;
  });

  // at reload time active and trigger link
  let current_url = this.location.path();
  if (this.location['_baseHref']) {
    current_url = this.location['_baseHref'] + this.location.path();
  }
  const link = "a.nav-link[ href='" + current_url + "' ]";
  const ele = document.querySelector(link);
  if (ele !== null && ele !== undefined) {
    const parent = ele.parentElement;
    const up_parent = parent.parentElement.parentElement;
    const last_parent = up_parent.parentElement;
    if (parent.classList.contains('pcoded-hasmenu')) {
      if (this.themeConfig.layout === 'vertical') {
        parent.classList.add('pcoded-trigger');
      }
      parent.classList.add('active');
    } else if (up_parent.classList.contains('pcoded-hasmenu')) {
      if (this.themeConfig.layout === 'vertical') {
        up_parent.classList.add('pcoded-trigger');
      }
      up_parent.classList.add('active');
    } else if (last_parent.classList.contains('pcoded-hasmenu')) {
      if (this.themeConfig.layout === 'vertical') {
        last_parent.classList.add('pcoded-trigger');
      }
      last_parent.classList.add('active');
    }
  }
}

}
